import React, { useCallback, useMemo } from 'react';
import { NodeChildsCountDTO } from 'business/models/Models';
import useRMLite from 'CustomHooks/useRMLite';

export interface FolderInfoPanelProps {
  info: NodeChildsCountDTO;
}
const FolderInfoPanel = (props: FolderInfoPanelProps) => {
  const { info } = props;
  const rmLite = useRMLite();

  const returnCountPanel = useCallback((heading, count) => {
    return (
      <div id={`folderinfopanel-returncountpanel-${heading}-wrapper`} className="row" style={{ padding: '10px' }}>
        <div id={`folderinfopanel-returncountpanel-${heading}`} className="nodeInfo nodeLabel col-4">{heading}</div>
        <div id={`folderinfopanel-returncountpanel-count-${count}`}className="nodeInfo col-6">{count}</div>
      </div>
    );
  }, []);

  const getData = useMemo(() => {
    if (info) {
      const nodeInfo = [];
      if (info.folderCount) {
        nodeInfo.push(returnCountPanel('Folder Count', info.folderCount));
      }
      if (info.projectsCount) {
        nodeInfo.push(returnCountPanel('Projects Count', info.projectsCount));
      }
      if (info.experimentCount) {
        nodeInfo.push(returnCountPanel('Experiments Count', info.experimentCount));
      }
      if (!rmLite) {
        if (info.screensCount) {
          nodeInfo.push(returnCountPanel('Screens Count', info.screensCount));
        }
        if (info.proteinsCount) {
          nodeInfo.push(returnCountPanel('Proteins Count', info.proteinsCount));
        }
        if (info.seedsCount) {
          nodeInfo.push(returnCountPanel('Seeds Count', info.seedsCount));
        }
        if (info.searchesCount) {
          nodeInfo.push(returnCountPanel('Searches Count', info.searchesCount));
        }
      }
      return nodeInfo;
    }
  }, [info]);

  return (
    <>
      <div id='folderinfopanel-wrapper' className="row" style={{ padding: '10px' }}>
        <div id='folderinfopanel-label' className="nodeInfo nodeLabel col-4">Folder Info</div>
      </div>
      {getData}
    </>
  );
};
export default FolderInfoPanel;
